import React, { useState, useEffect } from 'react';

const GalleryDump = () => {
  const [images, setImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);

  const plays = [
    'Sangue de Todas as Cores',
    'História do Coco',
    'O Jardim das Cerejeiras',
    'A Tempestade',
    'Hamlet',
    'Romeu e Julieta',
    'Macbeth',
    'Rei Lear'
  ];

  const photographers = [
    'João Silva',
    'Maria Santos',
    'Pedro Costa',
    'Ana Rodrigues',
    'Carlos Oliveira',
    'Sofia Pereira'
  ];

  useEffect(() => {
    loadImages();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const getRandomElement = (arr) => {
    return arr[Math.floor(Math.random() * arr.length)];
  };

  const loadImages = () => {
    if (loading) return;

    setLoading(true);

    setTimeout(() => {
      const newImages = [];
      const itemsToLoad = 12;

      for (let i = 0; i < itemsToLoad; i++) {
        const imageNumber = (page - 1) * itemsToLoad + i + 1;
        newImages.push({
          id: `img-${Date.now()}-${i}`,
          url: `https://picsum.photos/400/500?random=${imageNumber}`,
          play: getRandomElement(plays),
          photographer: getRandomElement(photographers),
          number: imageNumber
        });
      }

      setImages((prev) => [...prev, ...newImages]);
      setPage((prev) => prev + 1);
      setLoading(false);
    }, 500);
  };

  const handleScroll = () => {
    if (
      window.innerHeight + window.scrollY >= document.body.offsetHeight - 500 &&
      !loading
    ) {
      loadImages();
    }
  };

  const openModal = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setSelectedImage(null);
    document.body.style.overflow = '';
  };

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && selectedImage) {
        closeModal();
      }
    };

    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [selectedImage]);

  return (
    <div className="gallery-dump-react">
      <style>{`
        .gallery-dump-react {
          font-family: var(--font-primary, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif);
        }

        .gallery-container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 4rem 2rem;
        }

        .gallery-title {
          text-align: center;
          font-size: clamp(2.5rem, 5vw, 3.5rem);
          font-weight: 800;
          margin-bottom: 3rem;
          color: var(--color-text-primary, #111827);
          background: linear-gradient(135deg, #6d28d9 0%, #a855f7 100%);
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
          opacity: 0;
          animation: fadeInUp 0.6s ease forwards;
        }

        .gallery-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: 2rem;
          margin-bottom: 3rem;
        }

        .gallery-item {
          position: relative;
          cursor: pointer;
          transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          transform-origin: center;
          animation: float 6s ease-in-out infinite, fadeInUp 0.6s ease forwards;
          opacity: 0;
        }

        .gallery-item:nth-child(odd) { --rotation: -2deg; }
        .gallery-item:nth-child(even) { --rotation: 2deg; }
        .gallery-item:nth-child(3n) { --rotation: -1deg; }

        .gallery-item:nth-child(1) { animation-delay: 0.1s; }
        .gallery-item:nth-child(2) { animation-delay: 0.2s; }
        .gallery-item:nth-child(3) { animation-delay: 0.3s; }
        .gallery-item:nth-child(4) { animation-delay: 0.4s; }
        .gallery-item:nth-child(5) { animation-delay: 0.5s; }
        .gallery-item:nth-child(6) { animation-delay: 0.6s; }

        .gallery-item:hover {
          transform: rotate(0deg) scale(1.05);
          z-index: 10;
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0) rotate(var(--rotation, -2deg));
          }
          50% {
            transform: translateY(-10px) rotate(var(--rotation, -2deg));
          }
        }

        @keyframes fadeInUp {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .gallery-image {
          width: 100%;
          height: 350px;
          object-fit: cover;
          border-radius: 8px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
          transition: box-shadow 0.3s ease;
        }

        .gallery-item:hover .gallery-image {
          box-shadow: 0 15px 40px rgba(0, 0, 0, 0.25);
        }

        .gallery-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(to top, rgba(17,24,39,0.8) 0%, transparent 50%);
          opacity: 0;
          transition: opacity 0.3s ease;
          border-radius: 8px;
          display: flex;
          align-items: flex-end;
          padding: 1.5rem;
        }

        .gallery-item:hover .gallery-overlay {
          opacity: 1;
        }

        .gallery-info {
          color: white;
        }

        .gallery-info-title {
          font-size: 1.1rem;
          font-weight: 700;
          margin: 0 0 0.25rem 0;
        }

        .gallery-info-category {
          font-size: 0.9rem;
          font-weight: 500;
          margin: 0;
          opacity: 0.9;
        }

        .gallery-info-photographer {
          font-size: 0.85rem;
          opacity: 0.9;
          margin: 0;
        }

        .gallery-loading {
          text-align: center;
          padding: 2rem;
          font-size: 1.2rem;
          color: var(--color-text-muted, #9ca3af);
        }

        .gallery-loading.hidden {
          display: none;
        }

        .loading-spinner {
          display: inline-block;
          width: 30px;
          height: 30px;
          border: 3px solid rgba(109, 40, 217, 0.2);
          border-top-color: var(--primary-color, #6d28d9);
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        /* Modal Styles */
        .gallery-modal {
          position: fixed;
          inset: 0;
          background: rgba(17, 24, 39, 0.95);
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2rem;
          animation: fadeIn 0.3s ease;
          cursor: pointer;
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        .gallery-modal-content {
          max-width: 1000px;
          width: 100%;
          background: white;
          border-radius: 12px;
          overflow: hidden;
          animation: slideUp 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          cursor: default;
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(50px) scale(0.95);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        .gallery-modal-header {
          padding: 2rem;
          background: #f8f9fa;
          border-bottom: 1px solid #e9ecef;
        }

        .gallery-modal-title {
          font-size: 1.8rem;
          font-weight: 700;
          margin: 0 0 0.5rem 0;
          color: #111827;
        }

        .gallery-modal-subtitle {
          font-size: 1rem;
          color: #6b7280;
          margin: 0;
          font-weight: 500;
        }

        .gallery-modal-image-container {
          position: relative;
          width: 100%;
          max-height: 70vh;
          overflow: hidden;
          background: rgba(17, 24, 39, 1);
        }

        .gallery-modal-image {
          width: 100%;
          height: auto;
          display: block;
        }

        .gallery-modal-close {
          position: absolute;
          top: 1rem;
          right: 1rem;
          width: 40px;
          height: 40px;
          background: rgba(17, 24, 39, 0.7);
          border: none;
          border-radius: 50%;
          color: white;
          font-size: 1.5rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
          z-index: 10;
        }

        .gallery-modal-close:hover {
          background: rgba(17, 24, 39, 0.9);
          transform: rotate(90deg);
        }

        /* Responsive */
        @media (max-width: 768px) {
          .gallery-grid {
            grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
            gap: 1.5rem;
          }

          .gallery-image {
            height: 300px;
          }

          .gallery-modal-content {
            margin: 1rem;
          }

          .gallery-modal-header {
            padding: 1.5rem;
          }

          .gallery-modal-title {
            font-size: 1.4rem;
          }
        }
      `}</style>

      <div className="gallery-container">
        <h1 className="gallery-title">Gallery Dump</h1>

        <div className="gallery-grid">
          {images.map((image) => (
            <div
              key={image.id}
              className="gallery-item"
              onClick={() => openModal(image)}
            >
              <img
                src={image.url}
                alt={image.photographer}
                className="gallery-image"
                loading="lazy"
              />
              <div className="gallery-overlay">
                <div className="gallery-info">
                  <h3 className="gallery-info-title">{image.play}</h3>
                  <p className="gallery-info-category">{image.category}</p>
                  <p className="gallery-info-category">{image.photographer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className={`gallery-loading ${loading ? '' : 'hidden'}`}>
          <div className="loading-spinner"></div>
          <div style={{ marginTop: '1rem' }}>Loading more images...</div>
        </div>
      </div>

      {selectedImage && (
        <div className="gallery-modal" onClick={closeModal}>
          <button
            className="gallery-modal-close"
            onClick={closeModal}
            aria-label="Close modal"
          >
            ×
          </button>
          <div className="gallery-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="gallery-modal-header">
              <h2 className="gallery-modal-title">{selectedImage.play}</h2>
              <p className="gallery-modal-subtitle">
                Photography by {selectedImage.photographer}
              </p>
            </div>
            <div className="gallery-modal-image-container">
              <img
                src={selectedImage.url}
                alt={selectedImage.play}
                className="gallery-modal-image"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GalleryDump;
